export default {
  namespaced: true,

  state: {
    urls: null,
    selected: null,
    openMainCategories: [],
    categoriesTreeData: [],
    categoriesPositionData: {},
    categoriesPositionDataString: '{}',
    originalCategoriesTreeString: '',
    originalCategoriesPositionsData: {},
    originalCategoriesPositionsDataString: '{}',
    form: {
      type: null,
      parent: null,
      category: null,
    },
    showDeleteOptions: false,
    isLoading: false,
  },

  mutations: {
    SELECT(state, category) {
      if (state.selected === null || state.selected.id !== category.id) {
        state.showDeleteOptions = false;
      }
      state.selected = category;
    },
    DESELECT(state) {
      state.selected = null;
      state.showDeleteOptions = false;
    },
    OPEN_MAIN(state, categoryId) {
      state.openMainCategories.push(categoryId);
    },
    CLOSE_MAIN(state, categoryId) {
      state.openMainCategories = state.openMainCategories.filter((openCateg) => openCateg !== categoryId);
    },
    SET_FORM_TYPE(state, type) {
      state.form.type = type;
    },
    SET_FORM_PARENT(state, parentCategory) {
      state.form.parent = parentCategory;
    },
    SET_FORM_CATEGORY(state, category) {
      state.form.category = category;
    },
    SET_URLS(state, urls) {
      state.urls = urls;
    },
    SET_CATEGORIES_TREE(state, categories) {
      state.categoriesTreeData = categories;

      if (state.originalCategoriesTreeString === '') {
        state.originalCategoriesTreeString = JSON.stringify(categories);
      }
    },
    SET_ORIGINAL_CATEGORIES_TREE_STRING(state, categories) {
      state.originalCategoriesTreeString = JSON.stringify(categories);
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_SHOW_DELETE_CONFIRMATION(state, show) {
      state.showDeleteOptions = show;
    },
    UPDATE_CATEGORIES_POSITIONS_DATA(state, data) {
      state.categoriesPositionData[data.id] = data.positions;
      state.categoriesPositionDataString = JSON.stringify(state.categoriesPositionData);
    },
    UPDATE_ORIGINAL_CATEGORIES_POSITIONS_DATA(state, data = null) {
      if (data !== null) {
        state.originalCategoriesPositionsData[data.id] = data.positions;
      } else {
        state.originalCategoriesPositionsData = _.clone(state.categoriesPositionData);
      }

      state.originalCategoriesPositionsDataString = JSON.stringify(state.originalCategoriesPositionsData);
    },
  },

  actions: {
    SELECT_CATEGORY({ commit }, category) {
      commit('SELECT', category);
    },
    OPEN_MAIN_CATEGORY({ commit }, categoryId) {
      commit('OPEN_MAIN', categoryId);
    },
    SET_FORM_TYPE({ commit }, type) {
      commit('SET_FORM_TYPE', type);
    },
    SET_FORM_PARENT({ commit }, parentCategory) {
      commit('SET_FORM_PARENT', parentCategory);
    },
    SET_FORM_CATEGORY({ commit }, category) {
      commit('SET_FORM_CATEGORY', category);
    },
    SET_CATEGORIES_TREE({ commit }, categories) {
      commit('SET_CATEGORIES_TREE', [...categories]);
    },
    ADD_CATEGORY_TO_TREE({ state, commit }, category) {
      const newCategory = category;
      newCategory.id = parseInt(newCategory.id, 10);
      newCategory.parentId = parseInt(newCategory.parentId, 10);
      newCategory.isEditable = typeof newCategory.isEditable === 'boolean' ? newCategory.isEditable : true;
      newCategory.isDeletable = typeof newCategory.isDeletable === 'boolean' ? newCategory.isDeletable : true;

      commit('SET_CATEGORIES_TREE', [...state.categoriesTreeData].map((mainCategory) => {
        const categ = { ...mainCategory };

        if (categ.id === newCategory.parentId) {
          categ.children.push(newCategory);
        }

        return categ;
      }));

      return newCategory;
    },
    REMOVE_CATEGORY_FROM_TREE({ state, commit }, data) {
      const {
        categoryId,
        deleteChildren,
      } = data;

      const removeCategory = (categories) => {
        const mappedCategories = categories;

        mappedCategories.forEach((category, index) => {
          if (category.id === categoryId) {
            mappedCategories.splice(index, 1);

            if (!deleteChildren) {
              category.children.reverse().forEach((child) => {
                mappedCategories.splice(index, 0, child);
              });
            }
          } else {
            const mappedCategory = category;

            mappedCategory.children = removeCategory(mappedCategory.children);

            mappedCategories.splice(index, 1, mappedCategory);
          }
        });

        return mappedCategories;
      };

      const newTree = [...state.categoriesTreeData];

      commit('SET_CATEGORIES_TREE', newTree.map((topLevelCategory) => {
        const mappedTopLevelCategory = topLevelCategory;

        mappedTopLevelCategory.children = removeCategory(mappedTopLevelCategory.children || []);

        return mappedTopLevelCategory;
      }).filter((categ) => !!categ));

      commit('SET_ORIGINAL_CATEGORIES_TREE_STRING', state.categoriesTreeData);
    },
    UPDATE_CATEGORIES_TREE_STRING({ state, commit }) {
      commit('SET_ORIGINAL_CATEGORIES_TREE_STRING', state.categoriesTreeData);
    },
    UPDATE_CATEGORY({ state, commit }, category) {
      const updatedCategory = _.clone(category);
      updatedCategory.id = parseInt(updatedCategory.id, 10);
      updatedCategory.parentId = parseInt(updatedCategory.parentId, 10);

      function updateCategoriesRecursive(categories) {
        return categories.map((categ) => {
          const mappedCategory = categ;

          if (mappedCategory.id === updatedCategory.id) {
            updatedCategory.children = mappedCategory.children || [];

            return updatedCategory;
          }

          mappedCategory.attributesets = updatedCategory.attributesets || [];

          mappedCategory.children = updateCategoriesRecursive(mappedCategory.children);

          return mappedCategory;
        });
      }

      commit('SET_CATEGORIES_TREE', updateCategoriesRecursive([...state.categoriesTreeData]));
    },
  },

  getters: {
    IS_SELECTED: (state) => (categoryId) => (state.selected || {}).id === categoryId,
    IS_OPEN: (state) => (mainCategoryId) => state.openMainCategories.includes(mainCategoryId),
    FORM_SHOW: (state) => ((
      state.form.type === 'edit' && state.form.category && state.urls.update
    ) || (
      state.form.type === 'create' && state.form.parent && state.urls.store
    )),
    FORM_ATTRIBUTESETS_SHOW: (state) => (
      state.form.type === 'attributesets' && state.form.category && state.urls.getAttributesets && state.urls.getInheritedAttributesets && state.urls.updateAttributesets
    ),
    SELECTION_SHOW: (state) => state.form.type === 'selection',
    FORM_TYPE: (state) => state.form.type,
    FORM_PARENT: (state) => state.form.parent,
    FORM_CATEGORY: (state) => state.form.category,
    HAS_CHANGES: (state) => state.categoriesPositionDataString !== state.originalCategoriesPositionsDataString,
  },
};
